import {
  useFetch,
  postFetch,
  deleteFetch,
  patchFetch,
  upload,
} from "./utils.js";

const API_URL = import.meta.env.VITE_API_ENDPOINT + "api/"; //'http://localhost:3000/api/';

/**
 * EVENT ENDPOINTS
 */
export const listEvents = async () => {
  let { data, error } = await useFetch(API_URL + "events/list");
  //  let { data, error } = await useFetch(API_URL+'events/list') //@TODO: CORS support needs to be added for this
  return data;
};

export const getEvent = async (id) => {
  let { data, error } = await useFetch(API_URL + "events/" + id + "?depth=1");
  return data;
};

export const saveEvent = async (dataObj) => {
  let { data, error } = await postFetch(API_URL + "events", dataObj);
  return data;
};

export const updateEvent = async (id, dataObj) => {
  console.log("update event", id, dataObj);
  let { data, error } = await patchFetch(API_URL + "events/" + id, dataObj);
  return data;
};

export const deleteEvent = async (id) => {
  let { data, error } = await deleteFetch(API_URL + "events/" + id);
  return data;
};

export const getEventBase = async (id) => {
  console.log("base?");
  let { data, error } = await useFetch(API_URL + "events/" + id + "?depth=0");
  return data;
};

export const getBooths = async (id) => {
  let { data, error } = await useFetch(API_URL + "booths/" + id);
  return data;
};

export const updateBooth = async (id, dataObj) => {
  console.log("update booth", id, dataObj);
  let { data, error } = await patchFetch(API_URL + "booths/" + id, dataObj);
  return data;
};

/**
 *
 * MEDIA UPLOAD
 */

export const uploadFile = async (fileData) => {
  let { data, error } = await upload(API_URL + "media", fileData);
  //  let { data, error } = await useFetch(API_URL+'events/list') //@TODO: CORS support needs to be added for this
  return data;
};

/*
 * TRIGGER FIGMA SYNC
 **/
export const doFigmaSync = async (eventId, figmaId) => {
  let {
    data: { data },
    error,
  } = await useFetch(API_URL + "events/" + eventId + "/" + figmaId);
  return data;
};

/**
 * USER ENDPOINTS
 */
export const userLogin = async (email, password) => {
  let { data, error } = await postFetch(API_URL + "users/login", {
    email: email,
    password: password,
  });
  return data;
};
export const userLogout = async (email, password) => {
  let { data, error } = await postFetch(API_URL + "users/logout", {});
  return data;
};

export const userConfirmEmail = async (token) => {
  let { data, error } = await postFetch(API_URL + `users/verify/${token}`);
  return data;
};

export const userRefreshToken = async (email, password) => {
  let { data, error } = await postFetch(API_URL + "users/refresh-token", {});
  return data;
};

export const userForgotPassword = async (email) => {
  let { data, error } = await postFetch(API_URL + "users/forgot-password", {
    email: email,
  });
  return data;
};

export const userResetPassword = async (token, password) => {
  let { data, error } = await postFetch(API_URL + "users/reset-password", {
    token,
    password,
  });
  return data;
};

export const userMe = async () => {
  let { data, error } = await useFetch(API_URL + "users/me");
  return data;
};

export const createUser = async (userObj) => {
  let { data, error } = await postFetch(API_URL + "users", userObj);
  return data;
};

export const updateUser = async (id, dataObj) => {
  let { data, error } = await patchFetch(API_URL + "users/" + id, dataObj);
  return data;
};

export const deleteUser = async (id) => {
  let { data, error } = await deleteFetch(API_URL + "users/" + id);
  return data;
};

export const getUsers = async () => {
  let { data, error } = await useFetch(API_URL + "users?limit=100");
  return data;
};

export const getUser = async (id) => {
  let { data, error } = await useFetch(API_URL + "users/" + id);
  return data;
};
